import { render, staticRenderFns } from "./ControlCambios.vue?vue&type=template&id=47227ba6&scoped=true&"
import script from "./ControlCambios.vue?vue&type=script&lang=js&"
export * from "./ControlCambios.vue?vue&type=script&lang=js&"
import style0 from "./ControlCambios.vue?vue&type=style&index=0&id=47227ba6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47227ba6",
  null
  
)

export default component.exports